import { render } from "./SubscriptionsTab.vue?vue&type=template&id=3db4fee9&scoped=true"
import script from "./SubscriptionsTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTab.vue?vue&type=script&lang=js"

import "./SubscriptionsTab.vue?vue&type=style&index=0&id=3db4fee9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db4fee9"]])

export default __exports__